import * as React from 'react';
import styled from 'styled-components';
import SplunkUIMessage from '@splunk/react-ui/Message';
import { toDimension } from './style';

const MessageContainer = styled.div<{ width: string | number; height: string | number }>`
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    ${p => toDimension({ width: p.width, height: p.height })};
`;

type MessageProps = {
    width: string | number;
    height: string | number;
    level: 'info' | 'warning' | 'error';
    message: string;
};

const Message = ({ width, height, level = 'info', message = '' }: MessageProps) => (
    <MessageContainer width={width} height={height} data-test="visualization-message">
        <SplunkUIMessage type={level} style={{ maxWidth: '100%' }}>
            {message}
        </SplunkUIMessage>
    </MessageContainer>
);

export default React.memo(Message);
